// hello-world.js
// 2026Jan19 Mon
console.log('Hello, world!');

var __imgName = "";
var __imgNameURL = "";
var __myProductMedia = "";
var __myThumbnailImg = "";
var __indexN = "";

function setImgNameURLfromQueryString() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    __imgName = urlParams.get("name");
    if (__imgName && __imgName.length > 0){
        __imgNameURL = 'https://verse.fit/cdn/shop/files/' + __imgName + '.jpg';
    }
    console.log("My image name: " + __imgName);
    console.log("My image URL: " + __imgNameURL);

}
/*
function setMyProductMediaID() {
//    const desktop = document.getElementById('myProductMedia2025Apr4');
//    const mobile = document.getElementById('myProductMedia2025Apr4');
    const desktop = document.getElementsByClassName('product-gallery')
    const mobile = document.getElementsByClassName('product-gallery')

    if ($(desktop).is(':visible')) {
        console.log('Desktop: ' + $(desktop).is(':visible'));
        __myProductMedia = desktop
        return;
    }
    console.log('Mobile: ' + $(mobile).is(':visible'));
    __myProductMedia = mobile;
}
    */

function setThumbnailImage(newImgURL) {
    //const myProductMedia = document.getElementById(__myProductMediaID);
    var myMediaListItems = __myProductMedia.querySelectorAll('[data-pf-type="MediaItem2"]');
    var myMediaListItem = myMediaListItems[0];
    var myThumbnailImage = myMediaListItem.getElementsByTagName('img')[0];
    myThumbnailImage.setAttribute('src', newImgURL);
    myThumbnailImage.setAttribute('srcset', newImgURL);
}

function swapCarouselImages(classNameOfCarousel, indexN) {

    //const thumbs_splide_container = __myProductMedia.getElementsByClassName('thumbs-splide')[0];
    const thumbs_splide_container = __myProductMedia.getElementsByClassName(classNameOfCarousel)[0];
    const myMediaListItems = thumbs_splide_container.querySelectorAll('img');

    var myThumbnailImageIndex0 = myMediaListItems[0];
    const srcIndex0 = myThumbnailImageIndex0.getAttribute('src');
    console.log('mySwap ' + srcIndex0);

    var myThumbnailImageIndexN = myMediaListItems[indexN];
    const srcIndexN = myThumbnailImageIndexN.getAttribute('src');    
    myThumbnailImageIndex0.setAttribute('src', srcIndexN);
    myThumbnailImageIndexN.setAttribute('src', srcIndex0);
}

function swapCarouselImagesMainSplideHelper(classNameOfCarousel, indexN) {
    indexN = indexN + 1;
    //const thumbs_splide_container = __myProductMedia.getElementsByClassName('thumbs-splide')[0];
    const thumbs_splide_container = __myProductMedia.getElementsByClassName(classNameOfCarousel)[0];
    const myMediaListItems = thumbs_splide_container.querySelectorAll('img');

    var myThumbnailImageIndex0 = myMediaListItems[0+1];
    const srcIndex0 = myThumbnailImageIndex0.getAttribute('src');
    console.log('mySwap ' + srcIndex0);

    var myThumbnailImageIndexN = myMediaListItems[indexN];
    var srcIndexN = myThumbnailImageIndexN.getAttribute('src');    
    myThumbnailImageIndex0.setAttribute('src', srcIndexN);
    myThumbnailImageIndexN.setAttribute('src', srcIndex0);
}


function swapThumbnailImages_OLD(indexN) {
    var myMediaListItems = __myProductMedia.querySelectorAll('[data-pf-type="MediaItem2"]'); //NOTE: MediaItem2 is a thumbnail
    var myMediaListItems = __myProductMedia.querySelectorAll('thumbs-splide');
    //var myMediaListItemIndex0 = myMediaListItems[0];
    var myThumbnailImageIndex0 = myMediaListItems[0].getElementsByTagName('img')[0];
    const srcIndex0 = myThumbnailImageIndex0.getAttribute('src');
    const srcsetIndex0 = myThumbnailImageIndex0.getAttribute('srcset');
    
    var myThumbnailImageIndexN = myMediaListItems[indexN].getElementsByTagName('img')[0];
    const srcIndexN = myThumbnailImageIndexN.getAttribute('src');
    const srcsetIndexN = myThumbnailImageIndexN.getAttribute('srcset');
    
    myThumbnailImageIndex0.setAttribute('src', srcIndexN);
    myThumbnailImageIndex0.setAttribute('srcset', srcsetIndexN);

    myThumbnailImageIndexN.setAttribute('src', srcIndex0);
    myThumbnailImageIndexN.setAttribute('srcset', srcsetIndex0);
}

/*
function setMainMediaImage(newImgURL) {
    //const myProductMedia = document.getElementById(__myProductMediaID);
    var myMainMedia = __myProductMedia.querySelector('[data-pf-type="MediaMain2"]'); //NOTE: MediaMain2 (not MediaItem2)
    if (myMainMedia) {
        var myMainMediaImage = myMainMedia.getElementsByTagName('img')[0];
        myMainMediaImage.setAttribute('src', newImgURL);
        myMainMediaImage.setAttribute('srcset', newImgURL);
        console.log("my check: " + myMainMediaImage);
    }
}
    */

function swapMainMediaImages(indexN) {
    //var myMediaListItems = __myProductMedia.querySelectorAll('[data-pf-type="MediaMain2"]')[0].getElementsByTagName('img'); //NOTE: MediaItem2 is a thumbnail
    var myMediaListItems = __myProductMedia.querySelectorAll('main-splide');
    //var myMediaListItemIndex0 = myMediaListItems[0];
    var myThumbnailImageIndex0 = myMediaListItems[0];
    const srcIndex0 = myThumbnailImageIndex0.getAttribute('src');
    const srcsetIndex0 = myThumbnailImageIndex0.getAttribute('srcset');
    
    var myThumbnailImageIndexN = myMediaListItems[indexN];
    const srcIndexN = myThumbnailImageIndexN.getAttribute('src');
    const srcsetIndexN = myThumbnailImageIndexN.getAttribute('srcset');
    
    myThumbnailImageIndex0.setAttribute('src', srcIndexN);
    myThumbnailImageIndex0.setAttribute('srcset', srcsetIndexN);

    myThumbnailImageIndexN.setAttribute('src', srcIndex0);
    myThumbnailImageIndexN.setAttribute('srcset', srcsetIndex0);
}

function setMyProductMediaID() {
  //__myProductMedia = document.getElementById('myProductMedia2025Apr4');
  __myProductMedia = document.getElementsByClassName('product-gallery')[0];
  //var myMediaListItems = __myProductMedia.querySelectorAll('[data-pf-type="MediaItem2"]');
}

function setIndexOfThumbnailFromQueryString(imgName) {
    //const myProductMedia = document.getElementById(__myProductMediaID);
    //console.log("myProductMedia" + myProductMedia);
    if (__myProductMedia == null) return false;
    //const myMediaListItems = __myProductMedia.querySelectorAll('[data-pf-type="MediaItem2"]');
    //const myMediaListItems = __myProductMedia.querySelector('thumbs-splide');
    const thumbs_splide_container = __myProductMedia.getElementsByClassName('thumbs-splide')[0];
    const myMediaListItems = thumbs_splide_container.querySelectorAll('img');

    for (i = 1; i < myMediaListItems.length; i++) {
        //var myMediaListItem = myMediaListItems[i];
        //var myThumbnailImage = myMediaListItem.getElementsByTagName('img')[0];
        var myThumbnailImage = myMediaListItems[i];
        __myThumbnailImg = myThumbnailImage;
        var targetImgURL = myThumbnailImage.getAttribute('src');
        targetImgURL = targetImgURL.toLowerCase(); 
        //console.log(i);
        //console.log(targetImgURL);
        //console.log(imgName);
        //console.log(targetImgURL.includes(imgName));
        if (targetImgURL.includes(imgName)) {
            console.log('FOUND');
            console.log(i);
            //myMediaListItem.remove();
            __indexN = i;
            return true;
        }
    }
    console.log('My media list items: ' + myMediaListItems);
    //myMediaListItems[1].remove();
    return false;
}

function swapMainSplide(classNameOfCarousel, imgName) {
    const splide_container = __myProductMedia.getElementsByClassName(classNameOfCarousel)[0];
    const myMediaListItems = splide_container.querySelectorAll('img');

    for (i = 1; i < myMediaListItems.length; i++) {
        
        var myThumbnailImage = myMediaListItems[i];
        __myThumbnailImg = myThumbnailImage;
        var targetImgURL = myThumbnailImage.getAttribute('src');
        targetImgURL = targetImgURL.toLowerCase(); 
        //console.log(i);
        //console.log(targetImgURL);
        //console.log(imgName);
        //console.log(targetImgURL.includes(imgName));
        if (targetImgURL.includes(imgName)) {
            console.log('FOUND in swapMainSplide');
            console.log(i);
            //__indexN = i;
            swapCarouselImages(classNameOfCarousel, i);
            swapCarouselImagesMainSplideHelper(classNameOfCarousel, i);
            return true;
        }
    }
    console.log('Not found in my media list items: ' + myMediaListItems);
    //myMediaListItems[1].remove();
    return false;
}

function run() { 
    setImgNameURLfromQueryString();
    setMyProductMediaID();
    setIndexOfThumbnailFromQueryString(__imgName);
    if (__indexN > 0) {
        swapCarouselImages('thumbs-splide', __indexN);
        swapMainSplide('main-splide', __imgName);
        //swapMainMediaImages(__indexN);
    }

/*
    if(__imgName == "keylon") {
        //setThumbnailImage(__imgNameURL);
        setIndexOfThumbnailFromQueryString(__imgName);
        swapThumbnailImages(__indexN);
        //setMainMediaImage(__imgNameURL);
        swapMainMediaImages(__indexN);
    }
*/
    
}

run();



//detectDeviceType();

//setMyProductMediaID();